import { render, staticRenderFns } from "./SingleBudget.vue?vue&type=template&id=594d661a&"
import script from "./SingleBudget.vue?vue&type=script&lang=js&"
export * from "./SingleBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleBudget.vue"
export default component.exports